module.exports = __webpack_public_path__ + "img/26_45.2ff99bb9.png";